import { render, staticRenderFns } from "./batchInsertDialog.vue?vue&type=template&id=89976660&scoped=true"
import script from "./batchInsertDialog.vue?vue&type=script&lang=js"
export * from "./batchInsertDialog.vue?vue&type=script&lang=js"
import style0 from "./batchInsertDialog.vue?vue&type=style&index=0&id=89976660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89976660",
  null
  
)

export default component.exports